import React from 'react';
export const AperzaUserContext = React.createContext(null);
export const useAperzaUserContext = () => React.useContext(AperzaUserContext);
export const AperzaUserProvider = ({ children, ...props }) => {
    return React.createElement(AperzaUserContext.Provider, { value: { ...props } }, children);
};
AperzaUserProvider.displayName = 'AperzaUserProvider';
